import type { ReactElement } from "react";

import { FlexColumn } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import {
    StyledFilterCheckbox,
    StyledFilterCheckboxContainer,
} from "app/pages/sales-intelligence/common-components/filters-panel/components/styles";
import type { WebsiteType } from "app/pages/sales-intelligence/domain/leads/types/enums";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import type FindWebsiteTypeFilter from "app/pages/sales-intelligence/modules/leads-search-filters/models/WebsiteTypeFilter/WebsiteTypeFilter";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

import { PREDEFINED_INCLUSION, TRANSLATION_PREFIX } from "./const";
import { StyledFilterContentContainer, StyledInnerListWrapper } from "./styles";
import { toggleSelection, checkSelection } from "./utils/utils";

const WebsiteTypeFilter = ({
    filter: { options },
    value,
    onFilterUpdate,
}: IFilterViewBaseProps<FindWebsiteTypeFilter>): ReactElement | null => {
    const handleSelect = (siteType: WebsiteType) => () => {
        const selection = toggleSelection(siteType, value?.types, options);
        onFilterUpdate({ inclusion: PREDEFINED_INCLUSION, types: selection });
    };

    const renderType = (siteType: WebsiteType) => {
        const { isSelected, isPartiallySelected } = checkSelection(siteType, value?.types, options);
        return (
            <StyledFilterCheckboxContainer key={siteType}>
                <StyledFilterCheckbox
                    selected={isSelected}
                    halfSelected={isPartiallySelected}
                    label={translate(`${TRANSLATION_PREFIX}.${siteType}`)}
                    onClick={handleSelect(siteType)}
                />
            </StyledFilterCheckboxContainer>
        );
    };

    const renderOption = (siteType: WebsiteType) => {
        const { isSelected } = checkSelection(siteType, value?.types, options);
        return (
            <StyledFilterCheckbox
                key={siteType}
                selected={isSelected}
                label={translate(`${TRANSLATION_PREFIX}.${siteType}`)}
                onClick={handleSelect(siteType)}
            />
        );
    };

    return (
        <StyledFilterContentContainer>
            {options.map((option) => {
                return (
                    <FlexColumn key={option.value}>
                        {renderType(option.value)}

                        {is.undefined(option.options) ? null : (
                            <StyledInnerListWrapper>{option.options.map(renderOption)}</StyledInnerListWrapper>
                        )}
                    </FlexColumn>
                );
            })}
        </StyledFilterContentContainer>
    );
};

export default WebsiteTypeFilter;
